@if (content.ordered) {
  <ol class="message-list ordered">
    @for (item of content.items; track $index) {
      <li>{{ item }}</li>
    }
  </ol>
} @else {
  <ul class="message-list unordered">
    @for (item of content.items; track $index) {
      <li>{{ item }}</li>
    }
  </ul>
}

